import {actions as A} from '../../constants/actions';

export const step9UpdateSavedRowData = ({tableType, values}) => dispatch => {
  dispatch({
    type: A.UPDATE_STEP_9_GRID_SAVED_COLUMNS,
    payload: {tableType, values}
  });
};
